module.exports = __webpack_public_path__ + "img/l-3.8eb08b17.jpg";